import React from 'react'
import { createPortal } from 'react-dom'

import CloseButton from './CloseButton'
import ModalWrapper from './ModalWrapper'
import styles from './styles.module.scss'

interface Props extends React.PropsWithChildren {
  noScrollClassName?: string
  onClose: () => void
}

const Modal: React.FC<Props> = ({ children, noScrollClassName, onClose }) => {
  const [mounted, setMounted] = React.useState(false)

  React.useEffect(() => {
    setMounted(true)

    return () => setMounted(false)
  }, [])

  return mounted
    ? createPortal(
        <ModalWrapper noScrollClassName={noScrollClassName} onClose={onClose}>
          <div className={styles.modal} id="modal">
            <CloseButton onClick={() => onClose()} />

            <div className={styles.modalInner}>{children}</div>
          </div>
        </ModalWrapper>,
        document.getElementById('modal-wrapper'),
      )
    : null
}

export default Modal
